import { render, staticRenderFns } from "./EUploadAvator.vue?vue&type=template&id=0d359c64"
import script from "./EUploadAvator.vue?vue&type=script&lang=js"
export * from "./EUploadAvator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29728efa34f7641bbb3742d4a0c0d7ae/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports